// extracted by mini-css-extract-plugin
module.exports = {"categoryText":"NavigationHeader_categoryText__cjM3f","slugText":"NavigationHeader_slugText__qg7eH","container":"NavigationHeader_container__O4i0s"};